import axiosClient from '../configs/axios';

// Service class to handle all delivery challan customer API calls
class salesorderService {
    // Get list of delivery challan customers with pagination and search
    async getsalesorder(params) {
        try {
            const response = await axiosClient.get(
                `/salesoder/list?page=${params.page}&&size=${params.size}&&searchKey=${params.searchKey}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Add new delivery challan customer
    async addsalesorder(data) {
        try {
            const response = await axiosClient.post('/salesoder/add', data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Edit or delete delivery challan customer
    async editDeletesalesorder(data) {
        try {
            const response = await axiosClient.put(`/salesoder/editDelete`, data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    async getsalesofficerdata(cust_id) {
        try {
            const response = await axiosClient.get(
                `/schedule-entry/salesofficernamelist?cust_id=${cust_id}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    async getSoSummary(params) {
    try {
        const response = await axiosClient.get('/salesoder/sosummary', { params });
        return response.data;
    } catch (error) {
        throw error;
    }
}

    async getSoTabledata(cust_id,po_no) {
        try {
            // const response = await axiosClient.get(
            //     `/salesoder/cyldata?cust_id=${cust_id}?po_no=${po_no}`
            // );
            const response = await axiosClient.get('/salesoder/cyldata', {
            params: {
                cust_id,
                po_no
            }
        });
            return response.data;
        } catch (error) {
            throw error;
        }
    }

     async getpendingSalesorder(params) {
        try {
            const response = await axiosClient.get(
                `/salesoder/pendingso?page=${params.page}&&size=${params.size}&&searchKey=${params.searchKey}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }
    
}

export default new salesorderService(); 